import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
import 'store/member';
import Store from 'store/store';
import Login from 'components/bolt/login/login';
import InfoScreen from 'components/bolt/infoScreen/infoScreen';
import FullScreenLoader from 'components/bolt/fullScreenLoader/fullScreenLoader';
import TicketArea from 'components/bolt/ticketArea/ticketArea';
import { loadSDK, setClientID } from 'helpers/credentials';
import { loadScript } from 'utils/utils';
import {
	REJECTED,
	CROSS,
	CLOSE
} from 'helpers/constants';
// import s from 'base/bolt/boltApp.sss';

export default class BoltApp extends BaseComp.default {
	componentDidMount() {
		loadSDK();
		loadScript('https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js');
		window.onAmazonLoginReady = setClientID;
		super.componentDidMount();
	}

	componentDidUpdate(prevProps, prevState) {
		const copy = this.state?.appState?.appData?.copy?.baseCopy || {};
		const prevCustomer = prevState?.appState?.showtimes?.customer;
		const customer = this.state?.appState?.showtimes?.customer;
		if (customer?.id && (prevCustomer?.id !== customer?.id)) {
			Store.emit('SHOW_LOGIN_SCREEN', { show: false });
			if (this.state?.appState?.showtimes?.desiredScreen === 'ticketArea') {
				if (customer.tickets?.length < 1) {
					Store.emit('SHOW_INFO_SCREEN', {
						type: REJECTED,
						ticketIcon: CROSS,
						message: copy.$NO_TICKETS_BOOKED,
						buttons: [{ text: copy.$BOOK_TICKETS, action: CLOSE }]
					});
				} else {
					Store.emit('SHOW_TICKET_AREA', true);
				}
				Store.emit('RESET_DESIRED_SCREEN');
			}
		}
		super.componentDidUpdate(prevProps, prevState);
	}

	renderMoreThings() {
		const showtimesStore = this.state?.appState?.showtimes || {};
		const appData = this.state?.appState?.appData || {};
		const client = this.state?.appState?.client || {};
		return (
			<div>
				<Login showtimesStore={showtimesStore} appData={appData} client={client} />
				<InfoScreen show={showtimesStore.showInfoScreen} appData={appData} data={showtimesStore.infoScreenData} ticketData={showtimesStore?.customer?.tickets} storedEarlyAccessCode={showtimesStore?.earlyAccessCode} />
				<TicketArea show={showtimesStore.showTicketArea} appData={appData} ticketData={showtimesStore?.customer?.tickets} client={client} />
				<FullScreenLoader show={showtimesStore.showFullScreenLoader} />
			</div>
		);
	}

	render(props, state) {
		const base = super.render(props, state);
		const amazonRoot = <div id="amazon-root" />;
		const moreThings = this.renderMoreThings();
		base.children.unshift(amazonRoot);
		base.children.push(moreThings);
		return base;
	}

}
